import React from 'react';
import Icon from '../../../components/AppIcon';

const AuditTrailTimeline = ({ auditTrail }) => {
  const getActionIcon = (actionType) => {
    const icons = {
      report_generated: 'FileText',
      variance_calculated: 'TrendingUp',
      department_breakdown: 'Building2',
      findings_identified: 'Search',
      status_change: 'RefreshCw',
      review_completed: 'CheckCircle',
      dlir_pack_prepared: 'Package',
      dlir_submitted: 'Send',
      dlir_acknowledged: 'CheckCheck'
    };
    return icons?.[actionType] || 'Activity';
  };

  const getActionColor = (actionType) => {
    if (actionType?.includes('acknowledged') || actionType?.includes('approved')) return 'var(--color-success)';
    if (actionType?.includes('submitted') || actionType?.includes('completed')) return 'var(--color-primary)';
    if (actionType?.includes('rejected') || actionType?.includes('failed')) return 'var(--color-error)';
    return 'var(--color-muted-foreground)';
  };

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return 'N/A';
    const date = new Date(timestamp);
    return date?.toLocaleString('en-PG', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center gap-2">
          <Icon name="History" size={20} color="var(--color-primary)" />
          <h3 className="font-heading font-semibold text-base md:text-lg text-foreground">
            Audit Trail
          </h3>
        </div>
        <p className="caption text-xs md:text-sm text-muted-foreground mt-1">
          Complete history of report actions and changes
        </p>
      </div>

      <div className="p-4 md:p-6">
        <div className="space-y-4">
          {auditTrail?.map((entry, index) => (
            <div key={entry?.id || index} className="flex gap-4">
              <div className="flex flex-col items-center">
                <div className="w-10 h-10 rounded-full bg-muted flex items-center justify-center flex-shrink-0">
                  <Icon 
                    name={getActionIcon(entry?.actionType)} 
                    size={18} 
                    color={getActionColor(entry?.actionType)} 
                  />
                </div>
                {index < auditTrail?.length - 1 && (
                  <div className="w-0.5 h-full bg-border mt-2" />
                )}
              </div>

              <div className="flex-1 pb-4">
                <div className="flex items-start justify-between gap-2 mb-1">
                  <p className="caption text-sm font-medium text-foreground">
                    {entry?.actionDescription}
                  </p>
                  <p className="caption text-xs text-muted-foreground whitespace-nowrap">
                    {formatTimestamp(entry?.performedAt)}
                  </p>
                </div>
                <p className="caption text-xs text-muted-foreground">
                  By {entry?.performedBy}
                </p>
                {entry?.changesMade && (
                  <div className="mt-2 p-2 bg-muted rounded text-xs font-mono">
                    <pre className="text-muted-foreground overflow-x-auto">
                      {JSON.stringify(entry?.changesMade, null, 2)}
                    </pre>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {(!auditTrail || auditTrail?.length === 0) && (
          <div className="py-8 text-center">
            <Icon name="History" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-3 opacity-50" />
            <p className="caption text-sm text-muted-foreground">No audit trail entries available</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuditTrailTimeline;